var JoyTaskState;
(function (JoyTaskState) {
    JoyTaskState["running"] = "running";
    JoyTaskState["suspended"] = "suspended";
    JoyTaskState["canceled"] = "canceled";
    JoyTaskState["completed"] = "completed";
})(JoyTaskState || (JoyTaskState = {}));
export default JoyTaskState;
//# sourceMappingURL=JoyTaskState.js.map